export default function isEmail(email: string): boolean {
    const re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect } = import.meta.vitest;
    describe('isEmail', () => {
        test('validates email', () => {
            expect(isEmail('test@test.com')).toBe(true);
            expect(isEmail('test@test.co.uk')).toBe(true);
            expect(isEmail('test@test.co.uk')).toBe(true);
            expect(isEmail('test@test')).toBe(false);
        });
    });
}

// #endregion
